import { useEffect, useState } from 'react';
import { SelectZui } from 'src/components/zui';
import { SelectItem } from 'src/@/components/ui/select';
import { Button } from 'src/@/components/ui/button';
import { Separator } from 'src/@/components/ui/separator';
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from 'src/@/components/ui/popover';
import Iconify from 'src/components/Iconify';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import { useSnackbar } from 'notistack';
import { RowInput } from 'src/components/forms/RowInput';
import { OptionsSelect } from 'src/@/components/shared';

//actions
import v2_actionEditarLead from 'src/actions/v2/crm/v2_actionEditarLead';
// ----------------------------------------------------------------------

export default function DrawerConvertLead({ user, lead, onCallback, configCrm }) {
    const [selectedReason, setSelectedReason] = useState(null);
    const [loading, setLoading] = useState(false);
    const [option, setOption] = useState(1);
    const { enqueueSnackbar } = useSnackbar();

    async function editarLead() {
        try {
            let data = {
                action: "editar_conversao",
                scope: {
                    motivo_perda: selectedReason,
                    convertido: option,
                    data_conversao: new Date()
                }
            };
            setLoading(true);
            await v2_actionEditarLead(lead._id, data, user.id);
            onCallback();
            setLoading(false);
            enqueueSnackbar('Negócio alterado com sucesso', { variant: 'success', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } });
        } catch (error) {
            setLoading(false);
            console.log('error', error);
            enqueueSnackbar('Erro ao alterar negócio', { variant: 'error', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } });
        }
    }

    useEffect(() => {
        return () => {
            setSelectedReason(null);
        };
    }, []);

    let newReasons = configCrm?.motivos?.map((item) => {
        return {
            value: item._id,
            label: item.name
        };
    });

    const salvarDesabilitado = !option || (option === 2 && !selectedReason);

    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button className="flex justify-center h-8" variant="outline" title="Marcar como venda ou perda">
                    <Iconify icon="material-symbols:social-leaderboard" className="mr-2" />
                    Marcar
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-80 z-[9999] rounded-xl dark:bg-[#222529] dark:border-[#383838]">
                <div className="flex items-center gap-2.5 mb-3">
                    <div className="w-8 h-8 rounded-lg bg-violet-50 dark:bg-violet-500/10 flex items-center justify-center shrink-0">
                        <Iconify icon="material-symbols:social-leaderboard" width={16} className="text-violet-600 dark:text-violet-400" />
                    </div>
                    <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">Resultado do negócio</p>
                </div>
                <div className="w-2/3">
                    <OptionsSelect
                        title="Marcar como"
                        options={[
                            { value: 1, label: 'Venda', color: 'bg-green-500' },
                            { value: 2, label: 'Perda', color: 'bg-red-500' },
                        ]}
                        value={option}
                        changeValue={(e) => {
                            setOption(e);
                        }}
                    />
                </div>

                {option === 2 && (
                    <div className="flex flex-col gap-2 mt-4">
                        <RowInput
                            label={'motivo da perda'}
                            input={
                                <SelectZui
                                    value={selectedReason}
                                    list={newReasons}
                                    fullWidth
                                    onChange={event => {
                                        setSelectedReason(event);
                                    }}
                                    itemSelect={(item) => (
                                        <SelectItem key={item.value} value={item.value}>
                                            {item.label}
                                        </SelectItem>
                                    )}
                                />
                            }
                        />
                    </div>
                )}

                <Separator className="my-4 bg-gray-200/60 dark:bg-[#383838]" />

                <ButtonLoading
                    loading={loading}
                    onClick={editarLead}
                    disabled={salvarDesabilitado}
                    className={`w-full ${salvarDesabilitado ? 'bg-slate-300 dark:bg-slate-600' : 'bg-[#7C3AED] hover:bg-[#6d28d9]'}`}
                >
                    {loading ? 'Salvando...' : (salvarDesabilitado ? 'Selecione um motivo' : 'Salvar')}
                </ButtonLoading>
            </PopoverContent>
        </Popover>
    );
}
